/* eslint-disable import/no-named-as-default */
// import SavedPrice from "../../../component/product/V2/SavedPrice";
// import WasPrice from "../../../component/product/V2/WasPrice";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { LimitedQuantityDetails } from "api/interfaces/product-api.type";
import { IPageContent } from "api/interfaces/static-content.type";
import classNames from "classnames";
import PAImage from "component/design-system/images/PAImage";
import PartNumber from "component/product/PartNumber";
import { RootState } from "interfaces/generics.type";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { isApparelProduct } from "util/product/apparel";
import { getProductHeading } from "../../../util/product/get-product-heading";
import RattingScript from "../../third-party/sitejabber/RattingScript";
import SiteJabberEachProduct from "../../third-party/sitejabber/SiteJabberEachProduct";
import ProductHeaderDetailWeb from "./ProductHeaderDetail";
import styles from "./ProductHeaderDetail.module.scss";
import ProductPagePrice from "./ProductPagePrice";

interface IProps {
  product: ICompactProduct;
  staticContent: IPageContent;
  maximumPrice?: number;
  minimumPrice?: number;
  limitedQuantityDetails: LimitedQuantityDetails;
  // showBreadCrumbs?: boolean;
  showPrice?: boolean;
}
// used on Product page and Line Page
function ProductPageHeader(props: IProps) {
  const {
    staticContent,
    manufacturer, limitedQuantityDetails,
    maximumPrice, minimumPrice, pageType,
    manufacturerPageUrl, displayInOneLine,
    hideRightSection = false, productPrice,
    product, desktopHeaderRightSection, fromSideMenu, showPrice,
    isMobile,
  } = props;
  const { pageDetails, productFeatures } = staticContent || {};
  const { currentPageType, urlInformation } = useSelector((store: RootState) => store.utils);
  const h1 = getProductHeading(product, pageDetails, currentPageType, urlInformation);
  const {
    corePrice = 0, price = 0, wasPrice = 0, outOfStock, sku, category, upc,
    description, thumbnail, productLines, additionalServices, partNumber,
  } = product || {};

  const manufactureImageUrl = product?.manufacturerSmallImageUrl || pageDetails?.manufacturerImageUrl;
  const isApparel = isApparelProduct(product);

  return (
    <div className={classNames(styles.headerContainer, {
      "p-10": fromSideMenu,
      [styles.apparel_header]: isApparel,
    })}
    >

      <SiteJabberEachProduct {...{
        upc,
        partNumber,
        sku,
        description,
        manufacturer,
        price,
        thumbnail,
        category,
        productLines,
      }}
      />

      <RattingScript />
      <div className={styles.mobile_brand_container}>
        <PAImage
          src={getRelativeImagePath(manufactureImageUrl)}
          width={isMobile ? 80 : 155}
          height={isMobile ? 24 : 42}
          alt={`Upgrade your ride with premium ${manufacturer} auto parts`}
          title={`Upgrade your ride with premium ${manufacturer} auto parts`}
          className={styles.image_section_manufacturer}
        />
        <HideIf show={partNumber}>
          <PartNumber product={product} className="m-l-10" />
        </HideIf>
      </div>

      <div className={classNames(styles.header_details, {
        [styles.sidemenu_header_details]: fromSideMenu,
      })}
      >
        <div>
          <ProductHeaderDetailWeb
            {...{
              h1,
              corePrice,
              price,
              wasPrice,
              manufacturer,
              partNumber,
              outOfStock,
              limitedQuantityDetails,
              maximumPrice,
              minimumPrice,
              pageType,
              category,
              additionalServices,
              manufacturerPageUrl,
              productPrice,
              product,
              productFeatures,
            }}
          />
        </div>

        <HideIf show={!hideRightSection}>
          <div>

            <HideIf show={showPrice}>
              <ProductPagePrice
                pageType={pageType}
                price={price}
                wasPrice={wasPrice}
                maximumPrice={maximumPrice}
                minimumPrice={minimumPrice}
                corePrice={corePrice}
                fromSideMenu={fromSideMenu}
                displayInOneLine={displayInOneLine}
                productSku={product?.sku}
                rewardsAfterPrice={isApparel}
              />
            </HideIf>

            {desktopHeaderRightSection}
          </div>
        </HideIf>
      </div>

    </div>
  );
}

export default ProductPageHeader;
